<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder"
    @click.self="closeModal">
    <div class="spl-modal spl-measure-modal">
      <div class="spl-modal__label">
        Add Measure to Problem Report
      </div>
      <div>
        <form-label>Measure ID</form-label>
        <form-filtered-select
          v-model="selectedMeasureID"
          :selected-key="selectedMeasureID"
          :options="measureOptions"
          :invalid="$v.selectedMeasureID.$error"
          @close="$v.selectedMeasureID.$touch()" />
        <span v-if="$v.selectedMeasureID.$error" class="error">You must add a measure ID</span>
      </div>
      <div class="spl-measure-modal__text">
        <form-label>Measure Text</form-label>
        <form-textarea
          v-model="measureText"
          placeholder="Please add the measure Text here"
          class="spl-measure-modal__measure-text"
          :invalid="$v.measureText.$error"
          @blur="$v.measureText.$touch()" />
      </div>
      <br>
      <span v-if="$v.measureText.$error" class="spl-measure-modal__text-error error">You must add a measure text</span>
      <div class="spl-modal__close" @click="closeModal" />
      <div class="row spl-measure-modal__buttons">
        <div class="col6">
          <form-button
            :wide="true"
            :secondary="true"
            @onClick="closeModal">Cancel</form-button>
        </div>
        <div class="col6">
          <form-button
            :wide="true"
            @onClick="submitModal()">Save</form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { mapState, mapActions } from 'vuex'
import { required, minValue } from 'vuelidate/lib/validators'
import { SetProblemReportMeasure } from '../../webApi/DataModels'
import { find } from 'lodash'
export default {
  mixins: [Helpers],
  props: [],
  data () {
    return {
      isVisible: false,
      selectedProblemReports: [],
      selectedMeasureID: -1,
      measureText: '',
      constants
    }
  },
  computed: {
    ...mapState('problemReport', ['measureOptions'])
  },
  validations: {
    measureText: {
      required
    },
    selectedMeasureID: {
      required,
      minValue: minValue(0)
    }
  },
  mounted () {
    if (this.measureOptions) {
      // Fix this to 'Partner confronted w/delay' 5 is the id that represents the entry
      this.selectedMeasureID = find(this.measureOptions, { value: 5 }).value
    }
  },
  methods: {
    ...mapActions('problemReport', ['updateProblemReportsWithMeasures']),
    openModal (selectedProblemReports, measureID, measureText) {
      this.selectedProblemReports = selectedProblemReports
      if (!isNaN(measureID)) {
        this.selectedMeasureID = measureID
      }
      this.measureText = measureText
      this.isVisible = true
    },
    submitModal () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.$emit('expiryActionSaving')
        const measure:SetProblemReportMeasure = {
          Problem_Report_ID: this.selectedProblemReports,
          Problem_Report_Measure_ID: this.selectedMeasureID,
          Problem_Report_Measure_Freetext: this.measureText
        }
        this.updateProblemReportsWithMeasures(measure).then(() => {
          this.$toast('You successfully set the expiry action.', constants.defaultToastOptions())
          this.$emit('onMeasureSaved')
        }).catch(() => {
          this.$emit('onMeasureSaved')
        })
        this.isVisible = false
      }
    },
    // Close the scan window
    closeModal () {
      this.isVisible = false
      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss">
  @import '../../variables.scss';

  .spl-measure-modal {
    &__text-error {
      margin-top: -16px;
    }
    &__buttons, &__text {
      margin-top: 20px;
    }
  }

</style>
